import api from '@/api'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'
import types from '@/types'

//Subject to be modified as more stats are added
export interface CompanyVideoViewStats {
  imps: number | null
  pcts_25: number | null
  pcts_50: number | null
  pcts_75: number | null
  pcts_100: number | null
}

export interface queryParams {
  companyId: string
  mediaTypes: string[]
  startDate?: string
  endDate?: string
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
}

export class CompanyVideoViewModel {
  public async fetch({
    companyId,
    mediaTypes,
    startDate,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
  }: queryParams): Promise<Report<CompanyVideoViewStats> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCompany.companyVideoViewStats')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        start_date: startDate,
        end_date: endDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<CompanyVideoViewStats>>()
  }
}
